<template>
  <div class="home-m content-part">
    <div class="banner">
      <template v-if="locale == 'CN'">
        <img
          class="banner-img"
          src="http://resource.jmjnsz.com/jmjn-portal/2023/08/14/24fb5d32-04b3-41c0-87f8-5a9c3850073a.png"
          alt=""
        />
      </template>
      <template v-else>
        <img
          class="banner-img"
          src="http://resource.jmjnsz.com/jmjn-portal/2023/08/14/09eac8e0-080b-49f3-b33a-026e0eef8d37.png"
          alt=""
        />
      </template>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-3" v-for="(i, index) in intro" :key="index">
          <div class="left-icon">
            <img
              :src="require(`./../assets/images/home/info_${index + 1}.png`)"
              alt=""
            />
          </div>
          <div class="right">
            <div class="content">
              <div class="ctx">
                <h3 class="out">
                  {{ i.pre }}
                  <CountTo :startVal="0" :endVal="i.content" :duration="3000" />
                  {{ i.unit }}
                </h3>
                <h3 class="in">
                  {{ i.pre }}
                  <CountTo :startVal="0" :endVal="i.content" :duration="3000" />
                  {{ i.unit }}
                </h3>
              </div>
            </div>
            <p class="desc">{{ i[`desc_${locale}`] }}</p>
          </div>
        </div>
      </div>
    </div>
    <div id="home-main">
      <div class="home-main-content">
        <img
          :src="require(`./../assets/images/home_m/3-${locale}.png`)"
          alt=""
        />
        <img
          :src="require(`./../assets/images/home_m/4-${locale}.png`)"
          alt=""
        />
        <img
          :src="require(`./../assets/images/home_m/5-${locale}.png`)"
          alt=""
        />
      </div>
      <div class="guide">
        <div class="left-info">
          <p class="p1" v-if="locale == 'CN'">IMPLEMENTATION GUIDELINES</p>
          <p class="p2">{{ currentLg.detailTitle3 }}</p>
          <div class="line">
            <img src="./../assets/img/line.png" alt="" />
          </div>
          <img
            class="p3"
            :class="locale == 'CN' ? 'p3-cn' : 'p3-en'"
            :src="
              require(`./../assets/images/home/${
                locale == 'CN' ? '8-CN.jpg' : '8-EN.png'
              }`)
            "
            alt=""
          />
        </div>
        <div class="right-imgs">
          <swiper :options="mySwiperOption">
            <swiper-slide v-for="i in 3" :key="i">
              <div class="guide-list">
                <div class="guide-item">
                  {{ guideList[i - 1][`name_${locale}`] }}
                </div>
              </div>
              <img
                :src="require(`./../assets/images/home/guide_${i - 1}.jpg`)"
                width="100%"
              />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CountTo from "vue-count-to";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import language from "./../language/home/index";
export default {
  data() {
    return {
      mySwiperOption: {
        pagination: {
          el: ".swiper-pagination", //与slot="pagination"处 class 一致
          clickable: true, //轮播按钮支持点击
        },
        //自动播放
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        //循环
        loop: true,
      },
      projectList: [],
      newsList: [],
      bannerList: [],
      intro: [
        {
          pre: "+",
          content: 50,
          unit: "%",
          desc_CN: "信息化管理效率",
          desc_EN: "Efficiency of information management",
        },
        {
          pre: "+",
          content: 30,
          unit: "%",
          desc_CN: "建筑能源系统能效",
          desc_EN: "Energy efficiency of building energy systems",
        },
        {
          pre: "-",
          content: 30,
          unit: "%",
          desc_CN: "设备管理费用",
          desc_EN: "Costs of equipment management",
        },
      ],
      guideList: [
        {
          name_CN: "制定ESG战略、评估实质性议题",
          name_EN: "Develop ESG strategy Evaluate substantive issues",
        },
        {
          name_CN: "ESG数据收集与处理",
          name_EN: "ESG data collection and processing",
        },
        {
          name_CN: "ESG管理供应商、调动利益相关方参与",
          name_EN:
            "ESG Management Supplier  Mobilize stakeholder participation",
        },
      ],
      timer: null,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    locale() {
      return this.$i18n.locale;
    },
    currentLg() {
      return language[this.locale];
    },
  },

  components: {
    // 注册子组件
    swiper,
    swiperSlide,
    CountTo,
  },
};
</script>
<style lang="less" scoped>
.home-m {
  width: 100%;
  #home-main {
    .home-main-content {
      img {
        vertical-align: bottom;
        width: 100vw;
      }
    }
  }
}
.container {
  .row {
    display: flex;
    justify-content: center;
    .col-3 {
      width: 33%;
      padding: 2vw 0;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .content {
      .ctx {
        flex: 1;
        position: relative;
        height: 5vh; /* 设置容器的高度，根据需要调整 */
        overflow: hidden;
      }
      h3 {
        font-size: 6vw;
        padding-bottom: 1vh;
        height: 4vh;
        text-align: center;
        line-height: 4vh;
      }
      .out {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        animation: slideUpAndDisappear 1s forwards; /* 设置动画持续时间和结束后保持最后状态 */
      }
      @keyframes slideUpAndDisappear {
        0% {
          transform: translateY(0);
        }
        100% {
          transform: translateY(-100%);
        }
      }
      .in {
        animation-name: slideInUp;
        animation-duration: 1.5s;
        animation-timing-function: ease-out;
        animation-fill-mode: both;
      }
      @keyframes slideInUp {
        0% {
          transform: translateY(100%);
          visibility: visible;
        }
        100% {
          transform: translateY(0);
          visibility: visible;
        }
      }
    }
    .left-icon img {
      height: 14vw;
    }
    .left {
      flex: 1;
    }
    p {
      text-align: center;
      font-size: 4vw;
    }
  }
}
.guide {
  padding: 4vh;
}
.left-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 2vw;
  .p1 {
    font-size: 4vw;
    font-family: SourceHanSansCN-Light, SourceHanSansCN;
    font-weight: 300;
    color: #1b263d;
    line-height: 4vh;
  }
  .p2 {
    font-size: 7vw;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #1b263d;
    text-align: center;
  }
  .line {
    margin: 1vh 0;
  }
  .p3-cn {
    height: 4vh;
  }
  .p3-en {
    height: 3vh;
  }
}
.guide-list {
  .guide-item {
    padding: 2vh 6vw;
    margin: 3vh 0 2vh 0;
    background: #1289d9 linear-gradient(90deg, #1289d9, #76dcc7);
    color: #fff;
    font-size: 4vw;
    border-radius: 4vh;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #ffffff;
  }
}
.right-imgs {
  // display: grid;
  // grid-template-columns: repeat(2, 1fr);
  img {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/home_m.vue